import React from "react";

const baseSvgProps = (viewBox = "0 0 400 200", maxWidth = 260) => ({
  width: "100%",
  height: "50%",
  viewBox,
  preserveAspectRatio: "xMidYMid meet",
  style: {
    maxWidth,
    display: "block",
  },
});

const textSmall = {
  fontSize: 12,
  fontWeight: 500,
};

const textMedium = {
  fontSize: 14,
  fontWeight: 500,
};

const textLarge = {
  fontSize: 18,
  fontWeight: 500,
};

const ArrowDefs = () => (
  <defs>
    <marker
      id="arrowhead"
      markerWidth="10"
      markerHeight="7"
      refX="10"
      refY="3.5"
      orient="auto"
    >
      <polygon points="0 0, 10 3.5, 0 7" fill="black" />
    </marker>
  </defs>
);

export const FinishFunnelSVG = () => (
  <svg {...baseSvgProps()}>
    <ArrowDefs />

    <line x1="50" y1="20" x2="50" y2="180" stroke="black" strokeWidth="2" strokeDasharray="5,5" />

    <line x1="50" y1="20" x2="150" y2="60" stroke="red" />
    <line x1="150" y1="60" x2="400" y2="60" stroke="red" />

    <line x1="50" y1="180" x2="150" y2="140" stroke="red" />
    <line x1="150" y1="140" x2="400" y2="140" stroke="red" />

    {[50, 150, 250, 350].map((x, i) => (
      <React.Fragment key={i}>
        <circle cx={x} cy="60" r="20" fill="#4e73df" />
        <text x={x} y="60" textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>F</text>

        <circle cx={x} cy="140" r="20" fill="#4e73df" />
        <text x={x} y="140" textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>F</text>
      </React.Fragment>
    ))}

    <line x1="0" y1="100" x2="200" y2="100" stroke="black" strokeWidth="2" markerEnd="url(#arrowhead)" />

    <circle cx="300" cy="100" r="20" fill="#f6c23e" stroke="#d9801b" strokeWidth="2" />
    <text x="300" y="100" textAnchor="middle" dominantBaseline="middle" style={textMedium}>
      20s
    </text>

    <text x="370" y="100" textAnchor="middle" dominantBaseline="middle" style={textMedium}>
      Exit →
    </text>
  </svg>
);

export const CheckpointLineSVG = () => (
  <svg {...baseSvgProps("0 0 500 200", 320)}>
    <ArrowDefs />

    <line x1="250" y1="30" x2="250" y2="170" stroke="black" strokeWidth="2" strokeDasharray="5,5" />

    {[30, 170].map((y, i) => (
      <React.Fragment key={i}>
        <circle cx="250" cy={y} r="15" fill="#4e73df" />
        <text x="250" y={y} textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>F</text>
      </React.Fragment>
    ))}

    <line x1="20" y1="100" x2="400" y2="100" stroke="black" strokeWidth="2" markerEnd="url(#arrowhead)" />
    <text x="330" y="90" textAnchor="middle" style={textMedium}>30m</text>
  </svg>
);

export const CombinedFinishSVG = () => (
  <svg {...baseSvgProps()}>
    <ArrowDefs />

    {[30, 170].map((y, i) => (
      <React.Fragment key={i}>
        <circle cx="100" cy={y} r="15" fill="#4e73df" />
        <text x="100" y={y} textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>F</text>
      </React.Fragment>
    ))}

    <line x1="100" y1="50" x2="100" y2="160" stroke="black" strokeDasharray="5,5" />
    <line x1="20" y1="100" x2="200" y2="100" stroke="black" />

    <rect x="250" y="60" width="100" height="80" stroke="red" fill="none" />

    {[250, 350].map((x, i) => (
      <React.Fragment key={i}>
        <circle cx={x} cy="60" r="20" fill="#4e73df" />
        <text x={x} y="60" textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>FA</text>

        <circle cx={x} cy="140" r="20" fill="#4e73df" />
        <text x={x} y="140" textAnchor="middle" dominantBaseline="middle" fill="white" style={textMedium}>FA</text>
      </React.Fragment>
    ))}

    <line x1="200" y1="100" x2="300" y2="100" stroke="black" markerEnd="url(#arrowhead)" />
    <text x="175" y="85" textAnchor="middle" style={textMedium}>10m</text>
  </svg>
);


export const MassStartSVG = () => (
  <svg {...baseSvgProps("0 0 600 200", 380)}>
    <ArrowDefs />

    <line x1="100" y1="20" x2="100" y2="180" stroke="black" strokeDasharray="5,5" />

    {[50, 100, 150].map((y, i) => (
      <line key={i} x1="100" y1={y} x2="500" y2={y} stroke="black" markerEnd="url(#arrowhead)" />
    ))}
  </svg>
);

export const ChasingStartSVG = () => (
  <svg {...baseSvgProps("0 0 600 200", 380)}>
    <ArrowDefs />

    <rect x="80" y="20" width="140" height="160" stroke="red" fill="none" />

    {[80, 220].flatMap((x) =>
      [20, 180].map((y, i) => (
        <React.Fragment key={`${x}-${y}-${i}`}>
          <circle cx={x} cy={y} r="20" fill="#4e73df" />
          <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" fill="white" style={textLarge}>S</text>
        </React.Fragment>
      ))
    )}

    <text x="150" y="80" textAnchor="middle" style={textLarge}>Start Area</text>

    <line x1="150" y1="100" x2="350" y2="100" stroke="black" markerEnd="url(#arrowhead)" />
  </svg>
);

export const NoSafetySVG = () => (
  <svg {...baseSvgProps("0 0 600 200", 380)}>
    <ArrowDefs />

    <text x="70" y="55" textAnchor="middle" style={textLarge}>Start</text>

    <path
      d="M120 50 L520 50 C550 50 550 50 550 80 L550 140 C550 170 550 170 520 170 L120 170"
      fill="none"
      stroke="black"
      markerEnd="url(#arrowhead)"
    />

    <text x="90" y="170" textAnchor="end" style={textLarge}>Finish</text>

    <circle cx="550" cy="120" r="20" fill="#4e73df" />
    <text x="550" y="120" textAnchor="middle" dominantBaseline="middle" fill="white" style={textLarge}>CP1</text>
  </svg>
);

export const YesSafetySVG = () => (
  <svg {...baseSvgProps("0 0 600 200", 380)}>
    <ArrowDefs />

    <text x="70" y="55" textAnchor="middle" style={textLarge}>Start</text>

    <path
      d="M120 50 L520 50 C550 50 550 50 550 80 L550 140 C550 170 550 170 520 170 L120 170"
      fill="none"
      stroke="black"
      markerEnd="url(#arrowhead)"
    />

    <text x="90" y="170" textAnchor="end" style={textLarge}>Finish</text>

    {[
      [200, 50, "SS1"],
      [280, 50, "SS2"],
      [280, 170, "SF1"],
      [200, 170, "SF2"],
    ].map(([x, y, label], i) => (
      <React.Fragment key={i}>
        <circle cx={x} cy={y} r="20" fill="#dfc94e" />
        <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" fill="white" style={textLarge}>
          {label}
        </text>
      </React.Fragment>
    ))}

    <circle cx="550" cy="120" r="20" fill="#4e73df" />
    <text x="550" y="120" textAnchor="middle" dominantBaseline="middle" fill="white" style={textLarge}>CP1</text>
  </svg>
);